// extracted by mini-css-extract-plugin
module.exports = {"LocationWrapper":"Location_LocationWrapper__3ztxE"};